/**
 * Chart palette, checked against the three forms of colour blindness. The brand blues could not
 * serve: only 6.6 apart, they are indistinguishable.
 */
export const FORECAST_COLORS = {
  /** Store stock: available, in transit and picking together. */
  storeStock: '#2a78d6',

  /** Warehouse stock. */
  warehouseStock: '#eb6834',

  /** Projected stock, desaturated on purpose: the same stock in an estimated state, not one more series. */
  projectedStock: '#64748b',

  /**
   * Outstanding supply. Plum rather than red: on a stock screen, red means stockout, and an
   * incoming delivery is good news.
   */
  outstandingSupply: '#862e9c',

  /** Sales curve. Ink, not a series colour. */
  sales: '#3C3C3F',

  /** « Today » marker. An annotation, hence the brand colour. */
  today: '#FFCF00',

  /** Background of the past band. */
  pastBand: '#f4f5f7',

  /** Chart surface, used to keep a hairline between the solid areas. */
  surface: '#ffffff',
} as const;

/** Id of the hatch pattern applied to the projected bar. */
export const PROJECTED_PATTERN_ID = 'forecast-projected-hatch';
